import { render, staticRenderFns } from "./HotelsSlider.vue?vue&type=template&id=c7f35f28"
import script from "./HotelsSlider.vue?vue&type=script&lang=js"
export * from "./HotelsSlider.vue?vue&type=script&lang=js"
import style0 from "./HotelsSlider.vue?vue&type=style&index=0&id=c7f35f28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports